import React from 'react';
import { withRouter } from 'react-router-dom';

import FieldModal from '../../../../components/modals/fieldModal';

class DeleteSessionModal extends React.Component {
	state = {
		submitting: false
	};

	delete = () => {
		const session = {};
		session[this.props.session._id] = true;
		this.props.submit(
			session,
			(error) => (
				error ? this.setState({ error: 'Error deleting session' }) : this.props.toggle(),
				this.props.history.push('./')
			)
		);
	};
	render() {
		const { isOpen, toggle, session } = this.props;
		const { submitting } = this.state;
		return (
			<div>
				<FieldModal
					size="small"
					isOpen={isOpen}
					modalTitle={"Delete Session"}
					bodyHeaderText={<span>You are about to delete <b>{session.name}</b> session from the event, this is irreversible,
						would you like to continue?</span>}
					bodyContent={() => {
						return (
							''
						)
					}}
					toggle={toggle}
					actionButtonLabel={!submitting ? 'Delete' : 'Deleting...'}
					actionButton={() => this.delete()}
					actionButtonDisabled={submitting}
					isDelete={true}
				></FieldModal>
			</div>

		);
	}
}

export default withRouter(DeleteSessionModal);
